const choose = (items) => items[Math.floor(Math.random() * items.length)];
const shuffle = (items) => {
 for (let i=items.length-1;i>0;i--) {const j=Math.floor(Math.random()*(i+1));[items[i],items[j]]=[items[j],items[i]];}
 return items;
};
const selectPhoto = (slideshow,id) => {
 const slides=[...slideshow.querySelectorAll('slideshow-slide')];
 const index=slides.findIndex(slide=>slide.getAttribute('slide-id')===id);
 if(index<0)return;
 slideshow.setAttribute('initial-slide',String(index));
 const observer=new IntersectionObserver(entries=>{
  if(entries.some(entry=>entry.isIntersecting)){
   observer.disconnect();
   requestAnimationFrame(()=>requestAnimationFrame(()=>slideshow.select({id},undefined,{animate:false})));
  }
 },{threshold:0.01});
 observer.observe(slideshow);
};
const productEntries=new Set();
const ready = async (root=document) => {
 if(window.location.pathname.replace(/\/$/,'')==='/collections/all'){
  const heading=document.querySelector('#MainContent h1');
  const newest=new URLSearchParams(window.location.search).get('sort_by')==='created-descending';
  const label=newest?'New arrivals':'Shop all';
  if(heading&&heading.textContent.trim()!==label)heading.textContent=label;
 }

 root.querySelectorAll('[data-mp-featured-grid]:not([data-variety-ready])').forEach(grid=>{
  grid.dataset.varietyReady='true';
  const cards=shuffle([...grid.querySelectorAll('[data-mp-featured-item]')]);
  const selected=[];
  const take=(predicate)=>{const index=cards.findIndex(predicate);if(index>=0)selected.push(cards.splice(index,1)[0]);};
  take(card=>card.dataset.handle==='maple-puck-original-hoodie');
  take(card=>card.dataset.mpYouth==='true');
  take(card=>card.dataset.mpYouth==='false'&&card.dataset.mpHeadwear!=='true'&&!card.dataset.handle.startsWith('maple-puck-original'));
  take(card=>card.dataset.mpHeadwear==='true');
  cards.unshift(...selected);
  cards.forEach((card,index)=>{card.hidden=index>=Number(grid.dataset.limit||6);grid.append(card);});
 });
 root.querySelectorAll('.mp-collection-grid').forEach(grid=>{
  const used=new Set([...grid.querySelectorAll('[data-mp-collection-photo][data-variety-ready] img')].map(image=>image.src));
  grid.querySelectorAll('[data-mp-collection-photo]:not([data-variety-ready])').forEach(card=>{
   card.dataset.varietyReady='true';
   const options=JSON.parse(card.querySelector('[data-mp-collection-options]').textContent||'[]');
   const isOriginals=card.getAttribute('href')?.endsWith('/maple-puck-originals');
   const candidates=options.filter(option=>!used.has(option.src)&&(isOriginals||!option.src.includes('maple-puck-original')));
   if(!candidates.length)return;
   const option=choose(candidates),image=card.querySelector('img');
   used.add(option.src);
   if(image){image.srcset='';image.src=option.src;image.alt=option.alt;}
  });
 });
 await Promise.all([customElements.whenDefined('slideshow-component'),customElements.whenDefined('product-card'),customElements.whenDefined('variant-picker')]);
 requestAnimationFrame(()=>requestAnimationFrame(()=>{
  const usedColours=new Map();
  root.querySelectorAll('[data-mp-photo-card]:not([data-variety-ready])').forEach(gallery=>{
   const card=gallery.closest('product-card'),slideshow=gallery.querySelector('slideshow-component');
   if(!card||!slideshow)return;
   let choices;try{choices=JSON.parse(gallery.querySelector('[data-mp-photo-options]').textContent);}catch{return;}
   if(!choices.length)return;
   const params=new URLSearchParams(window.location.search);
   const colour=params.get('filter.v.option.color')||params.get('filter.v.option.colour');
   if(colour)choices=choices.filter(photo=>photo.colour===colour);
   if(!choices.length)return;
   let last;try{last=sessionStorage.getItem('mp-cover:'+gallery.dataset.productId);}catch{}
   const fresh=choices.filter(photo=>String(photo.media)!==last);
   if(fresh.length)choices=fresh;
   const least=Math.min(...choices.map(photo=>usedColours.get(photo.colour)||0));
   const photo=choose(choices.filter(photo=>(usedColours.get(photo.colour)||0)===least));
   usedColours.set(photo.colour,(usedColours.get(photo.colour)||0)+1);
   gallery.dataset.varietyReady='true';gallery.dataset.mpPhotoChoice=photo.colour;
   try{sessionStorage.setItem('mp-cover:'+gallery.dataset.productId,String(photo.media));}catch{}
   const first=slideshow.querySelector('slideshow-slide'),image=first?.querySelector('img');
   if(image){image.srcset='';image.src=photo.src;image.alt=photo.alt;}
   gallery.removeAttribute('on:pointerenter');gallery.removeAttribute('on:pointerleave');
   if(first)selectPhoto(slideshow,first.getAttribute('slide-id'));
   card.applyVariantToLinks(String(photo.variant));
  });
  root.querySelectorAll('[data-mp-product-gallery]').forEach(gallery=>{
   const picker=document.querySelector('variant-picker[data-template-product-match="true"]');
   if(!picker)return;
   const id=gallery.dataset.mpProductId;
   if(!productEntries.has(id)){
    productEntries.add(id);
    if(!new URLSearchParams(location.search).has('variant')){
     const inputs=[...picker.querySelectorAll('input[data-option-name]')].filter(input=>/^(color|colour)$/i.test(input.dataset.optionName)&&input.dataset.optionAvailable==='true');
     if(inputs.length){const input=choose(inputs);if(!input.checked){input.click();return;}}
    }
   }
   if(gallery.dataset.varietyReady)return;
   gallery.dataset.varietyReady='true';
   const colour=picker.querySelector('input[data-option-name="Color"]:checked,input[data-option-name="Colour"]:checked')?.value;
   let photos;try{photos=JSON.parse(gallery.querySelector('[data-mp-photo-options]').textContent).filter(photo=>photo.colour===colour);}catch{return;}
   if(!photos.length)return;
   const photo=choose(photos),slideshow=gallery.querySelector('slideshow-component');
   if(slideshow)selectPhoto(slideshow,String(photo.media));
  });
 }));
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>ready(),{once:true});else ready();
document.addEventListener('shopify:section:load',event=>ready(event.target));
let pending;
new MutationObserver(records=>{if(records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1))){clearTimeout(pending);pending=setTimeout(()=>ready(),80);}}).observe(document.body,{childList:true,subtree:true});
